export const ContestFieldRequired = {
    NAME: 'name',
    DESCRIPTION: 'description',
    STARTDATE: 'startDate',
    ENDDATE: 'endDate',
    LIMITSCORE: 'limitScore'
}
